module.exports = __webpack_public_path__ + "img/icon-follow-empty.8f675a06.png";